var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6665 0.333313H3.33317C1.8665 0.333313 0.679837 1.53331 0.679837 2.99998L0.666504 19C0.666504 20.4666 1.8665 21.6666 3.33317 21.6666H13.9998V19H3.33317V5.66665L13.9998 12.3333L24.6665 5.66665V12.3333H27.3332V2.99998C27.3332 1.53331 26.1332 0.333313 24.6665 0.333313ZM13.9998 9.66665L3.33317 2.99998H24.6665L13.9998 9.66665ZM21.1198 24.3333L16.3998 19.6133L18.2798 17.7333L21.1065 20.56L26.7598 14.9066L28.6665 16.7866L21.1198 24.3333Z",
    fill: "#8DAA6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailAddressIcon);
export default __webpack_public_path__ + "static/media/emailAddressIcon.0f2393ab1366e977df9db5d385ea31d8.svg";
export { ForwardRef as ReactComponent };